module.exports = {"production":false,"baseUrl":"https://6lit26l7zl.execute-api.us-east-1.amazonaws.com/Prod/","emailHost":"https://dedql2ieab.execute-api.us-east-1.amazonaws.com/live/email/","token":"hertz_token","terrapassURL":"https://qa.terrapass.com/cart","terrapassUKURL":"https://qa.terrapass.co.uk/cart"}


//////////////////
// WEBPACK FOOTER
// ./src/environments/config.json
// module id = ./src/environments/config.json
// module chunks = main